<template>
  <div>
    <div class="basic-container">
      <el-card>
        <slot></slot>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "basicContainer"
};
</script>

<style lang="scss">
.avue-layout {
  height: 80% !important;
}
.basic-container {
  padding: 8px 10px;
  border-radius: 10px;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
  .el-card {
    width: 100%;
  }
  &:first-child {
    padding-top: 0;
  }
}
</style>
